import { NextPage } from 'next';
import React from 'react';

import PageContainer from '~/pages/auth/sign-in/containers/PageContainer';
import HeadTitle from '~/shared/components/HeadTitle';
import UnauthenticatedPage from '~/shared/containers/UnauthenticatedPage';

const Page: NextPage = () => {
  return (
    <UnauthenticatedPage>
      <HeadTitle title="Sign in" />
      <PageContainer />
    </UnauthenticatedPage>
  );
};

export default Page;
